const ScrollAnimate =  () => {
  const getClientHeight = () => document.documentElement.clientHeight;

  const isInScrollView = ({ top, bottom }: any) =>
    top < getClientHeight() && bottom > 0;

  const isDirectionAgnostic = (params: any) => typeof params === 'string';

  const isBiDirectional = (params: { down: any; up: any }) =>
    params.down && params.up;

  const hasBeenApplied = (current = '', prev = '') =>
    current.trim() !== prev.trim();

  const shouldResetAnimation = ({ params, isUpwards, repeat }: any) =>
    repeat && ((isUpwards && params.down) || (!isUpwards && params.up));

  const applyAnimationClass = (el: any, current: string, newClass = '') =>
    (el.className = `${current} ${newClass}`.trim());

  return {
    run(
      el: any,
      { value: params, modifiers }: any,
      { isUpwards, previousClassName = '' }: any
    ) {
      if (!isInScrollView(el.getBoundingClientRect())) {
        if (modifiers.repeat && isDirectionAgnostic(params)) {
          return applyAnimationClass(el, previousClassName);
        }
        return;
      }

      if (isDirectionAgnostic(params)) {
        return applyAnimationClass(el, previousClassName, params);
      }

      if (
        modifiers.repeat ||
        isBiDirectional(params) ||
        !hasBeenApplied(el.className, previousClassName)
      ) {
        const animationClass = isUpwards ? params.up : params.down;
        return applyAnimationClass(el, previousClassName, animationClass);
      }

      if (shouldResetAnimation({ params, isUpwards, ...modifiers })) {
        return applyAnimationClass(el, previousClassName);
      }
    }
  };
};

export default {
  install(app: any, opt: any) {
    app.directive('animate-onscroll', {
      mounted(el: any, binding: any) {
        let domRef: any = window;
        if (opt?.id) {
          domRef = document.getElementById(opt.id);
        } else if (opt?.tag == 'body') {
          domRef = document.body;
        }
        const scrollAnimate = ScrollAnimate();
        const previousClassName = el.className;
        let lastScrollTop = window.pageYOffset;
        domRef.addEventListener(
          'scroll',
          function() {
            const scrollTop = window.pageYOffset || domRef.scrollTop;
            const isUpwards = scrollTop < lastScrollTop;
            scrollAnimate.run(el, binding, { isUpwards, previousClassName });
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
          },
          false
        );
      }
    });
  }
};
